<template>
    <div ref="monitorIfScrolledImage" data-animation="offset">
        <UIImage class="image" :class="currentClass" v-bind="($props, $attrs)"></UIImage>
    </div>
</template>

<script>
import UIImage from './UIImage.vue';
import InViewportAnimationMixin from '~/mixins/InViewportAnimationMixin';
export default {
    components: {
        UIImage,
    },
    mixins: [InViewportAnimationMixin],
    data() {
        return {
            blurState: 0,
        };
    },
    computed: {
        currentClass() {
            switch (this.blurState) {
                case 0:
                    return 'blur';
                case 1:
                    return 'unblurred';
                case 2:
                    return 'blurred';

                default:
                    break;
            }
        },
    },
    methods: {
        onEnter() {
            this.blurState = 1;
        },
        onExit() {
            this.blurState = 2;
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes unblur {
    0% {
        filter: blur(7px);
    }
    100% {
        filter: blur(0px);
    }
}

@keyframes blur {
    0% {
        filter: blur(0px);
    }
    100% {
        filter: blur(7px);
    }
}

.unblurred {
    animation: unblur 2s;
}

.blurred {
    animation: blur 2s;
}

.blur {
    filter: blur(7px);
}

.image {
    border-radius: $border-radius-default;
    animation-fill-mode: forwards;
}
</style>
